import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';

import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import CTB from '~/components/CTB';
import useFeature from '~/hooks/useFeature';

interface UpsellResourcesBannerProps {
  title?: string;
  desc?: string;
  isCloneWP?: boolean;
  accountProdInstaId?: string | undefined;
}

const UpsellResourcesBanner = ({
  title = undefined,
  desc = undefined,
  isCloneWP = false,
  accountProdInstaId = undefined,
}: UpsellResourcesBannerProps) => {
  const { t } = useTranslation('addSites');
  const [canUpgrade, ,] = useFeature('hosting_upgrade');

  return (
    <Alert severity={isCloneWP ? 'error' : 'info'} sx={{ border: 'none' }}>
      <AlertTitle>{title}</AlertTitle>
      <Stack spacing={2}>
        {desc}
        <Stack direction="row" spacing={2}>
          <Link
            component={RouterLink}
            to="/resources"
            state={{ prodInstaId: accountProdInstaId }}
          >
            {t('resourcesBanner.cta')}
          </Link>
          {canUpgrade && (
            <CTB
              product="HOSTING_UPGRADE"
              data={{
                prodInstId: accountProdInstaId,
              }}
            >
              {/* @ts-ignore */}
              <Typography variant="body" noWrap>
                {t('resourcesBanner.upgradeHosting')}
              </Typography>
            </CTB>
          )}
        </Stack>
      </Stack>
    </Alert>
  );
};
export default UpsellResourcesBanner;
